import React, {Fragment} from 'react'

export default ({children, delimiter = '•'}) => {
  // Ignore null/undefined items
  const cleanChildren = React.Children.toArray(children)

  return (
    <div className='delimited-list'>
      {cleanChildren.map((child, index) => {
        const isLast = index === cleanChildren.length - 1

        return (
          <Fragment key={child.key || index}>
            {child}
            {!isLast && <span className='delimiter mx-2'>{delimiter}</span>}
          </Fragment>
        )
      })}
    </div>
  )
}
